import { ImportTransportationTable } from "../component/importTransportationList/ImportTransportationTable";
export const ImportTransportationListPage = () => {
  return (
    <>
      <ImportTransportationTable />
    </>
  );
};
